import axios from 'axios'
import url from '../urls'
import { resolveTyperBoundStudentId } from '../../utils/typerNormalize'

function buildResultPostBody (data) {
  const assignmentId =
    data?.assignmentId ?? data?.teacherTyperAssignmentId ?? data?.id
  const fromPayload = parseInt(data?.studentId, 10)
  const studentId =
    Number.isFinite(fromPayload) && fromPayload > 0
      ? fromPayload
      : resolveTyperBoundStudentId()
  return {
    ...data,
    assignmentId,
    studentId
  }
}

export default {
  add (_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(url.TyperAssignmentResultUrl, buildResultPostBody(data))
        .then((response) => resolve(response))
        .catch((error) => reject(error))
    })
  },
  getByAssignmentId (_context, data) {
    return new Promise((resolve, reject) => {
      const assignmentId =
        data?.assignmentId ?? data?.teacherTyperAssignmentId ?? data?.id
      axios
        .get(url.TyperAssignmentResultUrl, { params: { assignmentId } })
        .then((response) => resolve(response))
        .catch((error) => reject(error))
    })
  },
  getByStudentId (_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${url.TyperAssignmentResultUrl}/student-assignment-results`, {
          params: data
        })
        .then((response) => resolve(response))
        .catch((error) => reject(error))
    })
  }
}
